// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11597":"8d4e636e","12893":"8d4e636e","18364":"8d4e636e","87932":"4bcda6b7"}[chunkId] + ".chunk.css";
};